<section class="operation">
  <div class="operation__header">
    <div class="operation__header-text">
      <mds-icon [key]="MdsIcon.HIGHLIGHT_ALT" [width]="32" [height]="32" [pathColors]="['var(--mds-color-dark-green-300)']" aria-hidden="true"></mds-icon>
      <div>
        <h2 class="operation__title">{{ stepTitle }}</h2>
        <p class="operation__subtitle">{{ stepSubtitle }}</p>
      </div>
    </div>
    <mds-step-indicator [steps]="steps" [activeStep]="currentStep"></mds-step-indicator>
  </div>

  <div class="operation__columns">
    @if (sourceSection) {
      <mds-card [icon]="MdsIcon.LINE_START_DIAMOND" [title]="sourceSection.name" [headerIconColor]="'var(--mds-color-soft-green-400)'">
        @if (currentStep === 1 && hasMissingOperation(sourceSection)) {
          <mds-alert
            [text]="'This required operation detail was deleted. Select a replacement before saving.'"
            [type]="'warning'"
          ></mds-alert>
        }
        @if (!sectionsReady) {
          <mds-loader role="status" aria-label="Loading operation data"></mds-loader>
        } @else {
          @if (currentStep === 2 && cardDataMap['op_source_pg']) {
            <mds-object-card [data]="cardDataMap['op_source_pg']"></mds-object-card>
          }
          <div
            [class.operation__form--hidden]="currentStep === 2"
            (formValueChanged)="formValueChanged(sourceSection.name, $event)"
            [lines]="sourceSection.lines"
            [parents]="data?.targetRid"
            [schema]="sourceSection"
            [sharedModel]="sharedModel"
            mdsInlineFormSchema
          ></div>
        }
      </mds-card>
    }

    <div class="operation__right-column">
      @if (targetSection) {
        <mds-card [icon]="MdsIcon.LINE_END_CIRCLE" [title]="targetSection.name" [headerIconColor]="'var(--mds-color-soft-green-400)'">
          @if (currentStep === 1 && hasMissingOperation(targetSection)) {
            <mds-alert
              [text]="'This required operation detail was deleted. Select a replacement before saving.'"
              [type]="'warning'"
            ></mds-alert>
          }
          @if (!sectionsReady) {
            <mds-loader role="status" aria-label="Loading operation data"></mds-loader>
          } @else {
            @if (currentStep === 2 && cardDataMap['op_target_pg']) {
              <mds-object-card [data]="cardDataMap['op_target_pg']"></mds-object-card>
            }
            <div
              [class.operation__form--hidden]="currentStep === 2"
              (formValueChanged)="formValueChanged(targetSection.name, $event)"
              [lines]="targetSection.lines"
              [parents]="data?.targetRid"
              [schema]="targetSection"
              [sharedModel]="sharedModel"
              mdsInlineFormSchema
            ></div>
          }
          @if (currentStep === 1) {
            <div class="operation__copy-action">
              <mds-button
                type="secondary"
                [icon]="MdsIcon.COPY"
                [isIconLeft]="true"
                (click)="chooseSameAsOriginal()"
                [disabled]="!sharedModel.Inputs.op_source_pg"
              >
                Choose same as original
              </mds-button>
            </div>
          }
        </mds-card>
      }

      @if (processSection && (sharedModel.Inputs.op_target_pg || currentStep === 2)) {
        <mds-card [icon]="MdsIcon.ARROW_CIRCLE_RIGHT" [title]="processSection.name" [headerIconColor]="'var(--mds-color-soft-green-400)'">
          @if (currentStep === 1) {
            <p class="operation__process-description">Choose which path should we use for calculations.</p>
          }
          @if (!sectionsReady) {
            <mds-loader role="status" aria-label="Loading operation data"></mds-loader>
          } @else {
            @if (currentStep === 2 && cardDataMap['op_target_process']) {
              <mds-object-card [data]="cardDataMap['op_target_process']"></mds-object-card>
            }
            <div
              [class.operation__form--hidden]="currentStep === 2"
              (formValueChanged)="formValueChanged(processSection.name, $event)"
              [lines]="processSection.lines"
              [parents]="data?.targetRid"
              [schema]="processSection"
              [sharedModel]="sharedModel"
              mdsInlineFormSchema
            ></div>
          }
        </mds-card>
      }
    </div>
  </div>
</section>
